import { useEffect } from 'react';
import {
  getMUICache,
  appendStyleSheet,
  getImageId,
  getImageUrl,
  getImageSize,
  convertEpochTime,
  GetFallBackImage,
  getListButtonIconPlain,
  fetchAnchorValue
} from '../../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import './ListViewThree.css';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const {
    item,
    isSimilarStories,
    isViewport,
    cardTextColor,
    cardColor,
    showDate,
    showAuthor,
    anchorLinksValue
  } = props;
  const { hl, syn, au, imageid, pubInfo, wu, upd, tn, du } = item;
  const cache = getMUICache();
  let styles = require('./ListViewThree.css');
  appendStyleSheet('ListViewThree', styles);

  let imageSize = getImageSize(imageid);
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

      useEffect(()=>{
          EagerLoadImages()
      },[]);

  return (
    <CacheProvider value={cache}>
      <a
        role="link"
        aria-label="Next Page"
        href={wu?.startsWith('http') ? wu : wu?.startsWith('/') ? wu : '/' + wu}
        target={fetchAnchorValue(anchorLinksValue, wu?.startsWith('http') ? wu : wu?.startsWith('/') ? wu : '/' + wu)}
        className="themeThreeListViewWraperAnchor"
        style={{ backgroundColor: cardColor }}
      >
        {(tn == 'QUIZ' || tn == 'SURVEY') && (
          <div className="themeThreeListViewWraper QuizSurveMainWrapper">
            <div className="themeThreeListViewImageWraper QuizSurveImageListWrapper">
              {isSimilarStories ? (
                imageSize && isViewport ? (
                <picture>
                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                    <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                </picture>
                ) : imageSize && !isViewport ? (
                <picture>
                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                    <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                </picture>
                ) : null
              ) : imageSize ? (
                <picture>
                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  {isViewport ? (
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                  ) : (
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                  )}
                </picture>
              ) : (
                <img src={GetFallBackImage()} alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
              )}
            </div>

            <div className="themeThreeListViewContentWraper">
              <div className="themeThreeListViewTitle" style={{ color: cardTextColor }} > {hl} </div>
              <div className="themeThreedateAgencyWrap">
                {showDate && (
                  <p className="ThemeThreeCommonAuthorWrapper">
                    {convertEpochTime(upd, 'updated', 'DD MMM YYYY')}
                  </p>
                )}
                {showAuthor && au != '' && (
                  <p className="themeThreeHeroLayoutDateTimeAgency">
                    By <span className="manageAuthorName">{au}</span>
                  </p>
                )}
              </div>

              <div className="themeThreeListViewDiscription">
                <p style={{ color: cardTextColor }} dangerouslySetInnerHTML={{ __html: syn }}></p>
              </div>

              <div className="themeThreeQuizButton">
                <button>{tn == 'QUIZ' ? 'Start Quiz' : 'Start Survey'}</button>
              </div>


            </div>
          </div>
        )}
        {(tn !== 'QUIZ' && tn !== 'SURVEY') && (
          <div className="themeThreeListViewWraper">
            <div className="themeThreeListViewImageWraper">
              {isSimilarStories ? (
                imageSize && isViewport ? (
              <picture>
                  <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
              </picture>) : imageSize && !isViewport ? (
              <picture>
                  <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
              </picture>) : null) : imageSize ? (
                <picture>
                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid),imageSize,212,119,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                <source media="(max-width: 767px)" srcSet={getImageUrl (getImageId(imageid),imageSize,135,76,pubInfo.baseDomain,false,props.CONSTANTS,'8')} />
                  {isViewport ? (
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                  ) : (
                    <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                  )}
                </picture>
              ) : (
                <img src={GetFallBackImage()} alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
              )}

              {(tn == 'MEDIAAUDIO' || tn == 'MEDIAVIDEO') && (
                <div className="themeThreeVideoListiconWrap">
                  <span className="VideoplayThemeThreeButton">
                    {getListButtonIconPlain(tn)}
                  </span>
                  <span className="videodu">{du}</span>
                </div>
              )}
            </div>

            <div className="themeThreeListViewContentWraper">
              <div
                className="themeThreeListViewTitle"
                style={{ color: cardTextColor }}
              >
                {hl}
              </div>
              <div className="themeThreedateAgencyWrap">
                {showDate && (
                  <p className="ThemeThreeCommonAuthorWrapper">
                    {convertEpochTime(upd, 'updated', 'DD MMM YYYY')}
                  </p>
                )}
                {showAuthor && au != '' && (
                  <p className="themeThreeHeroLayoutDateTimeAgency">
                    By <span className="manageAuthorName">{au}</span>
                  </p>
                )}
              </div>

              <div className="themeThreeListViewDiscription">
                <p style={{ color: cardTextColor }} dangerouslySetInnerHTML={{ __html: syn }}></p>
              </div>
            </div>
          </div>
        )}
      </a>
    </CacheProvider>
  );
};
export default Card;
